const palette = {
  modules: {
    sideMenu:
      "linear-gradient(173.89deg,#f6f6f6 -41.24%,#f6f6f6 -4.03%,#f6f6f6 9.89%,#f6f6f6 32.98%,#f6f6f6 54.35%,#f6f6f6 82.94%,#f6f6f6 100.43%,#f6f6f6 110.12%,#f6f6f6 113.54%)",
    sideMenuSecondary:
      "linear-gradient(91deg,#ffffff -16.89%,#ffffff 25.29%,#ffffff 59.49%,#eff8fa 100%)",
    sideMenuSecondaryDesktop:
      "linear-gradient(90.15deg,rgba(113,208,244,.1) 1.31%,rgba(113,208,244,0) 104.84%)",
    divider: "#ffffff20",
    readButton: "#339ae6",
    navbar: "#fff",
    appBarItem: "#768da9",
    appBar: "#fff",
    input: "#eff8fa",
    inputAction: "#1767BE",
    appBarrActive: "#1767BE",
    boxGradient: "#00264e33",
    border: "#00000010",
    checked: "#0ecb81",
    pending: "#e99831",
    colorChartMarginGreen: "#5BE12C",
    colorChartMarginOrange: "#EA4228",
    colorChartMarginYellow: "#F5CD19",
    colorChartMarginRed: "#FF0000",
    headerModules: "#ffffff0a",
    backgroundIconNotification: "#f6f6f6",
    backgroundHoverNotification:
      "linear-gradient(270.04deg,hsla(0,0%,100%,.08) -1.37%,hsla(0,0%,100%,0) 94.34%)",
    backgroundBadge: "#f50057",
    logoColor: "#cccccc",
    logoColor2: "#09f",
    tableHead: "#0f99fa20",
    headerShadow: "rgba(32,108,193,.501961)",
    buttonColor: "#ffffff",
    menuIconColor: '#000000',
    successModalBg: "#c7ffee",
    successModalBgBorder: "#eeeeee99",
  },

  action: {
    disabledBackground: "",
  },

  divider: "rgba(250, 250, 250, 0.1)",

  primary: {
    main: "#f6f6f6",
    dark: "#0f99fa40",
    light: "#eff8fa",
    alternate: "#0f99fa",
  },

  secondary: {
    main: "#0268b0",
    primary: "#fff",
    light: "#339ae6",
    lightest: "#71d0f450",
  },

  info: {
    main: "#eff8fa",
    secondary: "#eff8fa",
    lightest: "#71d0f4",
    light: "#0268b0",
  },

  text: {
    primary: "#333333",
    main: "#333333",
    light: "#ffffff",
    secondary: "#666666",
    alternate: "#4ca3dd",
  },

  background: {
    alert: "#e6f2fe",
    main: "#fff",
    default: "#f6f6f6",
    paper: "#ffffff",
    menu: "#f6f6f6",
    headerModal: "#1767BE",
    buttonAction: "#1767BE",
    button: "#0268b050",
    disabled: "#364254",
    lightest: "#939dac",
    coinSingle: "#eff8fa",
    boxShadowConvert: "rgb(23 172 190 / 30%)",
    boxShadowPrices: "rgb(23 172 190 / 30%)",
    primaryGradient:
      "linear-gradient(180deg, rgba(23,103,190,0.06) 0%, rgba(23,103,190,0.1) 30%)",
    convertTrade: "#fff",
    errorGradient:
      "linear-gradient(180deg,#fff 0%,rgba(255, 53, 71, 0.1) 100%),rgba(244, 244, 244, 0.04)",

    successGradient:
      "linear-gradient(180deg, #fff 0%, #27a17c1a 100%),#f4f4f40a",

    greenGradient:
      "linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(39,161,124,.6) 104.15%)",

    redGradient:
      "linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(255,53,71,.6) 104.15%)",

    blueReverseGradient:
      "linear-gradient(266.48deg,rgba(26,78,129,.42) -10.27%,rgba(54,110,155,.63) 5.39%,rgba(107,171,205,.22) 40.45%,rgba(119,184,216,.13) 60.09%,rgba(133,200,229,.06) 83.64%,rgba(147,216,242,0) 110.01%)",

    blueBottomToTopGradient:
      "linear-gradient(0deg,rgb(215 238 255) -7.62%,rgba(147,216,242,0))",

    blue: "linear-gradient(177.23deg, #5B9FEB -13.49%, #4082E6 -13.48%, #035AAB 109.75%)",
    red: " linear-gradient(177.23deg, #F96464 -13.49%, #A51437 109.75%)",
    tabButtonHover: "#044b98",
    tabButtonHoverColor: '#ffffff',
    tradeTypeButton: "#044b98",
    tradeTypeButtonActive: "#1767BE",
    tradeTypeButtonColor: "#ffffff",
    telegramCard: "#ffffff",
    telegramCardColor: "#333333",
    telegramColor: "#2481cc",
    telegramQrCodeBorderColor: "#4e0b88"
  },

  success: {
    main: "#27a17c",
    primary: "#27a17c",
    light: "#27a17c",
    secondary: "#27a145",
  },

  error: {
    main: "#ff3547",
  },

  warning: {
    main: "#ff9d00",
    secondary: "#ff9d00",
  },

  common: {
    white: "#ffffff",
    black: "#000000",
  },

  grey: {
    30: "#ddd",
    50: "#939dac",
    100: "#717781",
  },
};

export default palette;
